import { PreviewDocumentModalForm } from "./PreviewDocumentModalForm"

const PreviewDocumentModalFormWrapper = () => {
    return (<PreviewDocumentModalForm />)
}

export { PreviewDocumentModalFormWrapper }